// eslint-disable-next-line no-useless-escape
const illegalRe = /[\/\?<>\\:\*\|":]/g;
// eslint-disable-next-line no-control-regex
const controlRe = /[\x00-\x1f\x80-\x9f]/g;
const reservedRe = /^\.+$/;
const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;
const windowsTrailingRe = /[. ]+$/;
const punctuationRe = /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g;
export const sanitizePromptAsFilename = (prompt: string, maxLength: number) => {
  return prompt
    .replace(illegalRe, '')
    .replace(controlRe, '')
    .replace(reservedRe, '')
    .replace(windowsReservedRe, '')
    .replace(windowsTrailingRe, '')
    .replace(punctuationRe, '')
    .replace(/\s/g, '_')
    .substring(0, maxLength);
};
